// Forget-me-not flower brand mark — the approved AI-generated icon.
// MASTER FILES: /public/brand/marks/fmn-icon-{mono,colour}.png
// SVG fallback removed Feb 2026 once the sakura-style 5-petal sunburst
// design was locked in. See /app/memory/BRAND_GUIDELINES.md for full spec.
export function ForgetMeNotIcon({ size = 28, variant = "colour", className = "" }) {
    const src = variant === "mono"
        ? "/brand/marks/fmn-icon-mono.png"
        : "/brand/marks/fmn-icon-colour.png";
    return (
        <img
            src={src}
            width={size}
            height={size}
            alt=""
            className={className}
            aria-hidden="true"
            style={{ display: "inline-block", objectFit: "contain" }}
        />
    );
}
